import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { COGNITO_MAP, ORG, ROOT } from "../../util/constants";
import { setInsuranceOptions, setSpecialtyOptions } from "./sharedSlice";
import axiosApiInstance from "../../../utils/axiosConfig";

/**
 * Get the specialty options to populate navbar
 */
export const getSpecialtyOptions = createAsyncThunk(
    'auth/getSpecialtyOptions',
    async (_, { dispatch }) => {
    try {
        const response = await axios.get(
            ROOT + `/specialty-options?org=${ORG}`
        );
        let specialtyOptions = response?.data?.specialtyOptions;
        specialtyOptions = specialtyOptions.map((option) => option.name);
        dispatch(setSpecialtyOptions(specialtyOptions));
    } catch (e) {
        console.log(e);
        console.log("Error getting specialty options. Please try again later.");
    }
});

/**
 * Get the insurance opetions to populate navbar
 */
export const getInsuranceOptions = createAsyncThunk(
    'auth/getInsuranceOptions',
    async (_, { dispatch }) => {
    try {
        const response = await axios.get(
            ROOT + `/insurance-options?org=${ORG}`
        );
        let insuranceOptions = response?.data?.insuranceOptions;
        insuranceOptions = insuranceOptions.map((option) => option.name);
        dispatch(setInsuranceOptions(insuranceOptions));
    } catch (e) {
        console.log(e);
        console.log("Error getting insurance options. Please try again later.");
    }
});

/**
 * Get image urls from AWS S3
 * @param {Array} images 
 * @returns 
 */
export const getImageUrlsFromS3 = createAsyncThunk(
    'physician/getImageUrlsFromS3',
    async ({ images }) => {
    const imageUrls = [];
    for(let image of images) {
        const imageType = "image/" + image?.name?.split(".").pop();
        const body = {
            bucket: "caralyst-bug-images",
            key: `directory/${window.performance.now()}`,
            mime: imageType,
        }
        console.log(body)
        const imageUrl = await axiosApiInstance.post(COGNITO_MAP["s3_upload"], body)
        try {
            const headers = {
                'Content-Type': imageType,
            };
            // Make the PUT request to the pre-signed URL
            console.log(imageUrl)
            const imageUpload = await axios.put(imageUrl.data, image, { headers });
            if(imageUpload.status === 200) {
                imageUrls.push(imageUrl.data.split("?")[0]);
            }
        } catch(e) {
            console.log("Error uploading image to S3.")
            console.log(e)
        }
    }
    return imageUrls;
});

/**
 * Submit bug report to Jira
 * @param {String} summary 
 * @param {String} description 
 * @param {Array} images 
 * @returns 
 */
export const reportABug = createAsyncThunk(
    'physician/reportABug',
    async ({ summary, description, images }, { dispatch }) => {
    try {
        const imageUrls = await dispatch(getImageUrlsFromS3(images));
        // console.log({summary, description, imageUrls, ORG})
        const body = {
            summary,
            description,
            links: imageUrls,
        }
        const res = await axios.post(COGNITO_MAP["report_bug"], body);
        if(res.status === 200)
            return true;
        else
            return false;
    } catch(e) {
        // console.log("Error submitting bug report.")
        // console.log(e);
        return false;
    }
})